import { Patient } from '../../model/Patient';
import { PatientInfoDtoIn } from '../../generated';
import { fromPersonToGenerated } from './person.parser';
import { fromInsuranceCompanyToGenerated } from './insuranceCompany.parser';
import { fromPhoneToGenerated } from './phoneNumber.parser';

export const fromPatientToGenerated = (data: Patient): PatientInfoDtoIn => {
  return {
    ...fromPersonToGenerated(data),
    phoneNumber: fromPhoneToGenerated(data.phone),
    insuranceNumber: data.insuranceNumber,
    personalNumber: data.personalNumber,
    insuranceCompany: fromInsuranceCompanyToGenerated(data.insuranceCompany)
  };
};
